import React from 'react';
import { PROJECTS } from '../constants/data';
import ProjectCard from './ProjectCard';

const Projects = () => {
  return (
    <section id="work" className="section projects reveal">
      <div className="container">
        <div className="section-head">
          <span className="section-head__index">03</span>
          <h2 className="section-head__title">Selected Work</h2>
        </div>

        <div className="projects__grid">
          {PROJECTS.map((project) => (
            <ProjectCard key={project.id} project={project} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
